/**
 * Empty state component for PinnedClientsList
 * Handles both "no pinned clients" and "no search results" states
 */

import React from 'react';
import '../../../styles/components/clients/pinned-list/PinnedListEmptyState.css';

/**
 * PinnedListEmptyState component
 * @param {Object} props - Component props
 * @param {Array} props.pinnedClients - Array of all pinned clients
 * @param {Set} props.activeTierFilters - Set of active tier filters
 * @param {string} props.pinnedSearchQuery - Current search query
 * @param {Function} props.onClearFilters - Function to clear all filters
 * @returns {JSX.Element} Empty state component
 */
const PinnedListEmptyState = ({ 
  pinnedClients, 
  activeTierFilters, 
  pinnedSearchQuery,
  onClearFilters 
}) => {
  // If no clients are pinned at all, show the main empty state
  if (pinnedClients.length === 0) {
    return (
      <div className="pinned-clients-list__empty-state">
        <div className="pinned-clients-list__empty-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#c0c0c0" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <h3>No Pinned Clients</h3>
        <p>Click the pin icon next to client names in the country view to save them here.</p>
      </div>
    );
  }
  
  // Show filter/search no results state
  const hasActiveFilters = activeTierFilters.size > 0;
  const hasSearchQuery = pinnedSearchQuery.trim();
  
  return (
    <div className="pinned-clients-list__empty-state">
      <div className="pinned-clients-list__empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#c0c0c0" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>
      <h3>No Results Found</h3>
      <p>
        {hasActiveFilters && hasSearchQuery
          ? `No clients match your search "${pinnedSearchQuery}" and selected tier filters.`
          : hasActiveFilters
          ? `No clients match the selected tier filters.`
          : `No clients match your search "${pinnedSearchQuery}".`
        }
      </p>
      {(hasActiveFilters || hasSearchQuery) && (
        <button 
          className="pinned-clients-list__clear-all-filters-btn"
          onClick={onClearFilters}
        >
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default PinnedListEmptyState;
